import { Injectable, Output, EventEmitter } from '@angular/core';
import { BackendUrl } from '../backendUrl';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { take } from 'rxjs/operators';
@Injectable({
	providedIn: 'root'
})
export class ConnectionService {

	redirectUrl = BackendUrl;
	private urlSource = new BehaviorSubject({});
	actUrl = this.urlSource.asObservable();
	private theme = new BehaviorSubject('');
	private token = new BehaviorSubject('');
	private net = new BehaviorSubject('');
	themes = this.theme.asObservable();
	authtokens = this.token.asObservable();
	network = this.net.asObservable();
	@Output() public coinBalance = new EventEmitter();
	@Output() public tokenBalance = new EventEmitter();
	@Output() public jsonarray = new EventEmitter();
	@Output() public setRoute = new EventEmitter();
	@Output() public setLogin = new EventEmitter()
	@Output() public setColor = new EventEmitter()
	@Output() public setPrivateKey = new EventEmitter()
	
	@Output() public setBlock = new EventEmitter()

	private isLoggedIn = false;
	constructor(private http: HttpClient,
	) {
	}

	activeUrl(uri) {
		this.urlSource.next(uri);
	}

	getEmail() {
		return !!localStorage.getItem('Sastana_Token');
	}

	changeTheme(t) {
		this.theme.next(t);
	}

	setAccount(t) {
		this.token.next(t);
	}

	changeNetwork(n) {
		this.net.next(n);
	}

	postUrl(uri, data) {
		return this.http.post(this.redirectUrl + uri, data).pipe(take(1));
	}

	getUrl(uri) {
		return this.http.get(this.redirectUrl + uri).pipe(take(1));
	}

	// getSocketUrl(uri) {
	// 	return this.http.get(socketUrl + uri);
	// }

	// postSocketUrl(uri, data) {
	// 	return this.http.post(socketUrl + uri, data);
	// }

	posttokenRequest(uri, data) {
		var tokenHandling = this.getGen(this.redirectUrl + uri)
		const headers = new HttpHeaders()
			.set('cache-control', 'no-cache')
			.set('content-type', 'application/json')
			.set('4YdUxtZaWysZ', tokenHandling.token)
			.set('uiGcmJ3zfBQry8WopO8okw', tokenHandling.encrtpted_genT)
		return this.http.post(this.redirectUrl + uri, data, { headers: headers })
	}

	postRequest(uri, data, token) {
		const headers = new HttpHeaders()
			.set('cache-control', 'no-cache')
			.set('content-type', 'application/json')
			.set('Authorization', 'Bearer ' + token);
		return this.http.post(this.redirectUrl + uri, data, { headers: headers })
	}

	getRequest(uri, token) {
		const headers = new HttpHeaders()
			.set('cache-control', 'no-cache')
			.set('content-type', 'application/json')
			.set('Authorization', 'Bearer ' + token);
		return this.http.get(this.redirectUrl + uri, { headers: headers })
	}
	public getUsers(uri, name, data) {
		let queryParams = new HttpParams().append(name, data);
		return this.http.get(this.redirectUrl + uri, { params: queryParams });
	}


	filePostRequest(uri, data, token) {
		const headers = new HttpHeaders()
			.set('cache-control', 'no-cache')
			.set('Authorization', 'Bearer ' + token);
		return this.http.post(this.redirectUrl + uri, data, { headers: headers })
	}

	changebackground() {
		document.getElementById('loader_new').style.display = 'flex';

	}

	clearbackground() {
		document.getElementById('loader_new').style.display = 'none';
	}

	// public exportAsExcelFile(json: any[], excelFileName: string): void {

	// 	const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
	// 	const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
	// 	const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
	// 	this.saveAsExcelFile(excelBuffer, excelFileName);
	//   }

	//   private saveAsExcelFile(buffer: any, fileName: string): void {
	// 	const data: Blob = new Blob([buffer], {
	// 	  type: EXCEL_TYPE
	// 	});
	// 	FileSaver.saveAs(data, fileName + '_export_' + moment().format('ll') + EXCEL_EXTENSION);
	//   }

	idleLogout() {
		var t;
		window.onload = resetTimer;
		window.onmousemove = resetTimer;
		window.onmousedown = resetTimer;
		window.ontouchstart = resetTimer;
		window.onclick = resetTimer;
		window.onkeypress = resetTimer;
		window.addEventListener('scroll', resetTimer, true);

		function yourFunction() {
			//   sessionStorage.clear();
			localStorage.clear();
			window.location.href = '/explorer';
		}

		function resetTimer() {
			clearTimeout(t);
			t = setTimeout(yourFunction, 10 * 60 * 1000);  // time is in milliseconds
		}
	}

	randomStringRefferal() {
		let result = '';
		const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
		const charactersLength = characters.length;
		let counter = 0;
		while (counter < 6) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength));
			counter += 1;
		}
		result = 'Gn' + result
		return result;
	}

	getGen(url: any,) {
		var genT = this.randomStringRefferal()
		url = url + '/' + genT
		var date = Date.now()
		var ex_date = Math.round(date / 1000) + 10  //60
		const payload = {
			exp: ex_date,// tokens expiry date in milliseconds
			isHuman: true,
		};
		var token = this.signToken(payload, url)

		const encrtpted_genT = CryptoJS.AES.encrypt(genT, environment.token_key).toString();

		return { token: token, encrtpted_genT: encrtpted_genT }
	}

	base64url(source: any) {
		let encodedSource = CryptoJS.enc.Base64.stringify(source);
		encodedSource = encodedSource.replace(/=+$/, '');
		encodedSource = encodedSource.replace(/\+/g, '-');
		encodedSource = encodedSource.replace(/\//g, '_');
		return encodedSource;
	}

	signToken(payload: any, key: string) {
		var secret = key;
		let token: any = this.encodeToken(payload);
		var signature: any = CryptoJS.HmacSHA256(token, secret);
		signature = this.base64url(signature);
		var signedToken = token + "." + signature;
		return signedToken;
	}


	encodeToken(payload: any) {
		var header = {
			"alg": "HS256",
			"typ": "JWT"
		};
		var stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
		var encodedHeader = this.base64url(stringifiedHeader);
		var stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(payload));
		var encodedData = this.base64url(stringifiedData);
		var token = encodedHeader + "." + encodedData;
		return token
	}


}
